const ID_TOKEN_COOKIE_MAX_AGE = 60 * 60;
const REFRESH_TOKEN_COOKIE_MAX_AGE = 18 * 60 * 60;

export const getAuthCookieDomain = () => {
    const stage = process.env.STAGE;
    if (stage === 'prod') {
        return '.opus1.io';
    }
    if (stage === 'local' || stage?.startsWith('test')) {
        return '.opus1local.io';
    }
    if (stage) {
        return `.opus1${stage}.io`;
    }
    return '.opus1local.io';
};

/** Interim: mirror auth tokens into domain cookies until server Set-Cookie is verified everywhere. */
export const syncAuthCookies = (idToken, refreshToken) => {
    const domain = getAuthCookieDomain();
    const baseAttrs = `domain=${domain}; path=/; secure; samesite=lax`;

    const writeCookie = (name, value, maxAge) => {
        const encoded = value ? encodeURIComponent(value) : '';
        document.cookie = `${name}=${encoded}; ${baseAttrs}; max-age=${maxAge}`;
    };

    writeCookie(
        'idToken',
        idToken || null,
        idToken ? ID_TOKEN_COOKIE_MAX_AGE : 0,
    );
    writeCookie(
        'refreshToken',
        refreshToken || null,
        refreshToken ? REFRESH_TOKEN_COOKIE_MAX_AGE : 0,
    );
};
